import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { applicationPipelineReportQueryOptions } from '~bank-reports/service/applicationPipelineReportQueryOptions'

import { applicationPipelineReportSchema } from './schema'

export const applicationPipelineReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'application-pipeline',
    component: lazyRouteComponent(() => import('./ApplicationPipelineReport')),
    validateSearch: (search) => applicationPipelineReportSchema.parse(search),
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(applicationPipelineReportQueryOptions(deps))
    }
  })
